import { render, staticRenderFns } from "./NewHead.vue?vue&type=template&id=4b853fdc&scoped=true&"
import script from "./NewHead.vue?vue&type=script&lang=js&"
export * from "./NewHead.vue?vue&type=script&lang=js&"
import style0 from "./NewHead.vue?vue&type=style&index=0&id=4b853fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b853fdc",
  null
  
)

export default component.exports